import { render } from "./DataSearch.vue?vue&type=template&id=6dfb80e1&scoped=true"
import script from "./DataSearch.vue?vue&type=script&lang=js"
export * from "./DataSearch.vue?vue&type=script&lang=js"

import "./DataSearch.vue?vue&type=style&index=0&id=6dfb80e1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dfb80e1"]])

export default __exports__